import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

function colorFor(value, max, baseColor = [59, 130, 246]) {
  if (max === 0 || !value) return 'rgba(148, 163, 184, 0.08)';
  const intensity = Math.min(1, value / max);
  const [r, g, b] = baseColor;
  const alpha = 0.15 + intensity * 0.7;
  return `rgba(${r}, ${g}, ${b}, ${alpha.toFixed(3)})`;
}

export default function Heatmap({ rows, columns, getValue, rowLabel, onCellClick, baseColor }) {
  const max = Math.max(0, ...rows.flatMap((r) => columns.map((c) => getValue(r, c) || 0)));
  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Box sx={{ display: 'inline-grid', gridTemplateColumns: `minmax(160px, max-content) repeat(${columns.length}, minmax(80px, 1fr))`, gap: 0.5 }}>
        <Box />
        {columns.map((c) => (
          <Box key={c} sx={{ p: 0.75, fontSize: 11, fontWeight: 600, textAlign: 'center', color: 'text.secondary' }}>
            {c}
          </Box>
        ))}
        {rows.map((r, i) => (
          <React.Fragment key={i}>
            <Box sx={{ p: 0.75, fontSize: 12, fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {rowLabel(r)}
            </Box>
            {columns.map((c) => {
              const v = getValue(r, c) || 0;
              return (
                <Tooltip key={c} title={`${rowLabel(r)} · ${c}: ${v}`}>
                  <Box
                    onClick={onCellClick ? () => onCellClick(r, c, v) : undefined}
                    sx={{
                      p: 0.75,
                      fontSize: 12,
                      textAlign: 'center',
                      borderRadius: 0.5,
                      cursor: onCellClick ? 'pointer' : 'default',
                      bgcolor: colorFor(v, max, baseColor),
                      color: v > max * 0.5 ? 'white' : 'text.primary',
                      transition: 'transform .1s',
                      '&:hover': onCellClick ? { transform: 'scale(1.05)' } : undefined,
                    }}
                  >
                    {v || ''}
                  </Box>
                </Tooltip>
              );
            })}
          </React.Fragment>
        ))}
      </Box>
      {rows.length === 0 && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center', py: 2 }}>
          No data.
        </Typography>
      )}
    </Box>
  );
}
